import { useId, useState } from 'react';
import { Button } from '@/components/ui/button';
import { Checkbox } from '@/components/ui/checkbox';
import { Input } from '@/components/ui/input';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';

interface PickerProps {
  label: string;
  options: Array<{ value: string; label: string }>;
  values: string[];
  onChange: (values: string[]) => void;
}

export const CaseConferencingFilterPicker = ({ label, options, values, onChange }: PickerProps) => {
  const id = useId();
  const [search, setSearch] = useState('');
  const availableOptions = [...options, ...values.filter((value) => !options.some((option) => option.value === value)).map((value) => ({ value, label: value }))];
  const visibleOptions = availableOptions.filter((option) => option.label.toLowerCase().includes(search.toLowerCase()));

  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button type="button" variant="outline" size="sm" aria-label={`Filter ${label.toLowerCase()}`}>{label}{values.length > 0 ? ` (${values.length})` : ''}</Button>
      </PopoverTrigger>
      <PopoverContent className="space-y-2">
        <Input aria-label={`Search ${label.toLowerCase()} options`} value={search} onChange={(event) => setSearch(event.target.value)} />
        <div className="max-h-60 overflow-y-auto space-y-2">
          {visibleOptions.length === 0 && <p>No matching options.</p>}
          {visibleOptions.map((option, index) => (
            <div key={option.value} className="flex items-center gap-2">
              <Checkbox id={`${id}-${index}`} checked={values.includes(option.value)} onCheckedChange={(checked) => onChange(checked === true ? [...values, option.value] : values.filter((value) => value !== option.value))} />
              <label htmlFor={`${id}-${index}`}>{option.label}</label>
            </div>
          ))}
        </div>
      </PopoverContent>
    </Popover>
  );
};
